import { useOutletContext } from "react-router-dom";
import EventEmitter from "../../utils/eventEmitter";
import Axios from "../utils/axios"


export const loadPosSalesUpdate = async () => {
  try {
    const response = await Axios.get('pos-sales-update');
    const responseData = await response.data;
    return responseData;
    // return []
  }catch (err) {
    throw err;
  }
};


export const loadPosForSalesDetails = async () => {
  try {
    const response = await Axios.get('pos-sales-update/possalesupdates');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};
 

const loadOne = async (name) => {
  try {
    const respnse = await Axios.get('pos-sales-update/find/'+name);
    const responseData = await respnse.data;
    return responseData;
  }catch (err) {
    throw err;
  }
}

export const loadPosSaleUpdate = async (action) => {
  try {
    switch (action) {
      case 'new':
        return { salesUpdate: {}}
      default:
        const data = await loadOne(action);
        return data;
    }
  }catch (err) {
    throw err;
  }
}

const usePosSalesUpdateAPI = () => {
  const { success, error } = useOutletContext();


  const create = async (data) => {
    try {
      const respnse = await Axios.post('pos-sales-update', data);
      const responseData = await respnse.data;
      success(responseData.message);
      // EventEmitter.dispatch('sales_update_response', responseData.seo);
    }catch(err) {
      if (err.response?.data?.message) {
        error(err.response.data.message);
      }else if (err.message === 'Network Error') {
        error('Network Error');
      }
    }
  }

  const update = async (seo, data) => {
    try {
      const respnse = await Axios.put('pos-sales-update/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('sales_update_response', data.seo);
    }catch (err) {
      throw err;
    }
  }

  const printSalesUpdate = async () => {
    try {
      const respnse = await Axios.get('pos-sales-update/allpossales');
      const responseData = await respnse.data;
      return responseData;
    }catch (err) {
      throw err;
    }
  }

  return { create, update, printSalesUpdate };
};



export default usePosSalesUpdateAPI;


